import cx from 'classnames'
import Styles from './Cell.module.scss'

import { CellProps } from './Types'

const Cell = ({ children, width, className }: CellProps) => {
  return (
    <div className={cx(Styles.td, className)} style={{ width }}>
      {children}
    </div>
  )
}

export { Cell }
